module.exports = __webpack_public_path__ + "static/media/webdesign-services-img46.781d3585.jpg";